import React, {useContext} from "react";
import Layout from "../Layout";
import { AuthContext } from "../../authContext";
import Login from '../../Containers/Login'
import Loader from "../../Components/Loader";
import Modal from "../../Components/Modal";
const AppWrapper = (props) =>
{

  const authContext = useContext(AuthContext);
  if(authContext.loading)
    return (
      <Modal>
        <Loader title="Loading Control Panel..." />
      </Modal>
      );
    
  if(!authContext.login)
    return <Login />;
    
  return (
    <Layout />
  )
}


export default AppWrapper;